import { useCallback, useContext } from 'react'
import { useHistory } from 'react-router'
import FlashMessagesContext from 'services/FlashMessages/context'
import routes from 'services/RoutesProvider/routes'
import { isServerError, isNetworkError, getFirstError } from 'utils/apollo'
import { ApolloError } from '@apollo/client'
import useFavurTranslation from './useFavurTranslation'
import useSessionContext from './useSessionContext'

const useJamesApolloError = () => {
  const { refresh } = useSessionContext()
  const history = useHistory()
  const { t } = useFavurTranslation()
  const { setFlashMessage, removeAll } = useContext(FlashMessagesContext)

  const onError = useCallback(
    (error: ApolloError) => {
      if (isNetworkError(error)) {
        setFlashMessage(t('common.error.network'))
        return
      }

      if (isServerError(error)) {
        setFlashMessage(t('common.error.be.default'))
        return
      }

      const { graphQLErrors } = error

      if (graphQLErrors) {
        if (graphQLErrors.some(({ message }) => message === 'not logged in')) {
          refresh({ force: true, onComplete: () => history.go(0) })
          return
        }

        const firstError = getFirstError(error)
        const errorKey = firstError ? firstError.code : ''

        if (errorKey === 'common.error.be.termsAndConditions') {
          history.push(routes.termsAndConditionsUpdate)
          return
        }

        const errorText = t(errorKey)
        // If both are equal means the key is not on the translations file
        if (errorKey !== errorText) {
          removeAll()
          setFlashMessage(errorText)
        }
      }

      throw error
    },
    [history, refresh, removeAll, setFlashMessage, t],
  )

  return onError
}

export default useJamesApolloError
